// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import GPXImport from '~/gpx/import';
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

const dragNdrop = {
	_dom: {},
	_opts: null,

	test(files, opts) {
		const testFile = files[0];

		if (!testFile) {
			return;
		}

		if (typeof opts === "object") {
			this._opts = Object.assign({}, opts);
		}
		if (Mapy.ImageUploader.MIME_TYPES.includes(testFile.type) && this._opts.photo) {
			const { photo } = this._opts;
			const onUpload = () => {
				if (typeof photo === "function") {
					photo();
				}
			};
			const { user } = store.getState().user;
			this._close();
			const photoFiles = Array.prototype.slice.call(files).filter(function(file) {
				return Mapy.ImageUploader.MIME_TYPES.includes(file.type);
			});

			if (user.state === "green") {
				onUpload();
				Mapy.getComponent("imageUploader").dropFiles(photoFiles);
			} else {
				Mapy.getComponent("login").open({
					analyticsData: {
						loginOrigin: "photoUpload",
					},
					motivation: "photo",
				}).then(() => {
					onUpload();
					Mapy.getComponent("imageUploader").dropFiles(photoFiles);
				}, e => {});
			}
		} else if (testFile.name.toLowerCase().slice(-3) === "gpx" && this._opts.gpx) {
			if (typeof this._opts.gpx === "function") {
				this._opts.gpx();
			}
			this._close();
			const gpxFiles = Array.prototype.slice.call(files).filter(function(file) {
				return file.name.toLowerCase().slice(-3) === "gpx";
			});
			GPXImport.open({
				files: gpxFiles,
				detectFolder: true,
				logType: Mapy.getComponent("gpx").hasData() ? "" : "dragDrop"
			});
		} else {
			this._create(testFile);
		}
	},

	handleEvent(e) {
		switch (e.type) {
			case "click":
				if (this._dom.closeBtn.contains(e.target)) {
					this._close();
				}
				break;
			case "keydown":
				if (e.which == 27) {
					this._close();
				}
				break;
			case "dragover":
				e.preventDefault();
				this._dom.uploadArea.classList.add("active");
			break;
			case "dragenter":
				this._dom.uploadArea.classList.add("active");
			break;
			case "dragleave":
				this._dom.uploadArea.classList.remove("active");
			break;
			// drop na misto v dialogu - drop do mapy je v provider map
			case "drop":
				e.preventDefault();
				this._dom.uploadArea.classList.remove("active");
				if (e.dataTransfer && e.dataTransfer.files) {
					this.test(e.dataTransfer.files);
				}
			break;
			case "change":
				if (e.target.files.length) {
					this.test(e.target.files);
				}
			break;
		}
	},

	_create(file) {
		if (this._dom.container) return;
		let container = node("div", { className: "gpx-import" });
		let cover = node("div", { className: "gpx-import-cover" });
		let closeBtn = node("button", { className: "close-btn" });
		closeBtn.appendChild(icon("close"));
		closeBtn.appendChild(node("span", { textContent: _("close") }));
		closeBtn.addEventListener("click", this);
		let title = node("h2", { className: "title", textContent: _(this._opts.gpx ? "dragNdrop.titlePhotoGpx" : "dragNdrop.titlePhoto") });
		let uploadArea = node("label", { className: "upload-area" });
		let plus = node("span", { className: "plus" });
		let uploadTitle = node("h3", { className: "title", textContent: _(this._opts.gpx ? "dragNdrop.uploadPhotoGpx" : "dragNdrop.uploadPhoto") });
		let uploadInput = node("input", { type: "file" });
		uploadInput.setAttribute("multiple", "true");
		uploadInput.addEventListener("change", this);
		let error = node("p", { className: "error" });
		error.classList.add("ext-error");
		error.innerHTML = `${_("dragNdrop.fileExtError", { file: file.name })}<strong>${_(this._opts.gpx ? "dragNdrop.fileExtPhotoGpx" : "dragNdrop.fileExtPhoto")}</strong>`;
		container.appendChild(closeBtn);
		container.appendChild(title);
		container.appendChild(uploadArea);
		container.appendChild(error);
		uploadArea.appendChild(plus);
		uploadArea.appendChild(uploadTitle);
		uploadArea.appendChild(uploadInput);
		document.body.appendChild(cover);
		document.body.appendChild(container);
		let loader = node("div", { className: "loader" });
		let loaderImg = new Image();
		loaderImg.src = "/img/loader.gif";
		loaderImg.crossOrigin = "anonymous";
		loader.appendChild(loaderImg);
		uploadArea.addEventListener("drop", this);
		uploadArea.addEventListener("dragover", this);
		uploadArea.addEventListener("dragenter", this);
		uploadArea.addEventListener("dragleave", this);
		document.body.addEventListener("keydown", this);
		document.body.style.overflow = "hidden";
		Object.assign(this._dom, { container, cover, closeBtn, uploadArea, loader, error });
	},

	_close() {
		this._opts = null;
		if (!this._dom.container) return;
		this._dom.closeBtn.removeEventListener("click", this);
		this._dom.uploadArea.removeEventListener("drop", this);
		this._dom.uploadArea.removeEventListener("dragover", this);
		this._dom.uploadArea.removeEventListener("dragenter", this);
		this._dom.uploadArea.removeEventListener("dragleave", this);
		this._dom.container.remove();
		this._dom.cover.remove();
		this._dom.container = null;
		document.body.removeEventListener("keydown", this);
		document.body.style.overflow = "";
	}
};

export default dragNdrop;
